import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { ROOT_URL } from '../../../../redux/constants';
import { FormattedMessage } from 'react-intl';
import {
  Button,
  Typography,
  IconButton,
  FormGroup,
  TextField,
  MenuItem,
} from '@material-ui/core';
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import { fetchLevels } from '../../../../redux/actions';
import baseStyle from '../../../../styles/wizardBase';

class SoundSearchSkillDatabank extends Component {

  state = {
    tested: false,
    error: {},
    level: this.props.level.id ? this.props.level : {},
    selectedLevel:  '',
    difficulty: 'Easy',
    collection:  this.props.collection || '',
    lengthOfGame: this.props.lengthOfGame || 120,
    itemsInLeftList: this.props.itemsInLeftList || 4,
    itemsInRightList: this.props.itemsInRightList || 1,
    numberOfBoards: this.props.numberOfBoards || 1,
    unlimitedMode: this.props.unlimitedMode || 0,
  };

  componentDidMount() {
    this.props.fetchLevels();
    if (this.props.level.id) {
      const variables = JSON.parse(this.props.level.levelJson);
      this.setState({...variables, difficulty: this.props.level.difficulty, level: this.props.level, selectedLevel: this.props.level.id})
    }
    if (this.props.levelTemplate) {
      this.setState({ selectedLevel: this.props.levelTemplate.id})
    }
  }

  close = () => {
    this.props.close();
  };

  runTest = () => {
    const {
      tested,
      level,
      collection,
      lengthOfGame,
      itemsInLeftList,
      itemsInRightList,
      numberOfBoards } = this.state;
    const url = this.props.type === 'staff' ? `${ROOT_URL}/staff/${this.props.id}/objective-databank/test`: `${ROOT_URL}/admin/objective-databank/test`;
    if (tested) this.clearTest();
    axios.post(url, { levelVariables: JSON.stringify({ collection, lengthOfGame, itemsInLeftList, itemsInRightList, numberOfBoards }), templateId: level.id })
      .catch(err => console.log(err));
    this.setState({ tested: true });
  };

  clearTest = () => {
    const url = this.props.type === 'staff' ? `${ROOT_URL}/staff/${this.props.id}/objective-databank/test`: `${ROOT_URL}/admin/objective-databank/test`;
    axios.delete(url)
      .catch(err => console.log(err));
    this.setState({ tested: false })
  };

  handleChange = (ev) => {
    const value = ev.target.type === 'number' ? ev.target.value > 0 ? ev.target.value * 1 : '' : ev.target.value;
    this.setState({ [ev.target.name]: value })
  };

  handleLevelChange = (ev) => {
    const level = this.props.levels.find(level => level.id === ev.target.value);
    const { collection, lengthOfGame, itemsInLeftList, itemsInRightList, numberOfBoards } = JSON.parse(level.levelVariables);
    this.setState({  collection, lengthOfGame, itemsInLeftList, itemsInRightList, numberOfBoards, level, selectedLevel: ev.target.value })
  };

  handleSubmit = () => {
    const { level, difficulty, collection, lengthOfGame, itemsInLeftList, itemsInRightList, numberOfBoards } = this.state;
    const levelJson = JSON.stringify({ collection, lengthOfGame, itemsInLeftList, itemsInRightList, numberOfBoards });
    this.props.onSubmit({ levelTemplateId: level.id, levelJson, difficulty });
  };

  checkForErrors = (ev) => {
    if (!ev.target.value){
      this.setState({ error: {...this.state.error, [ev.target.name]: true }})
    }
    else {
      let error = this.state.error;
      delete error[ev.target.name];
      this.setState({ error })
    }
  };

  render()  {
    const { classes, open, close, back, levels, game } = this.props;
    const { tested, level, unlimitedMode, error } = this.state;
    const gameLevels = levels.filter(level => level.gameId === game.id);
    const disabled = this.state.itemsInRightList > 6 || this.state.itemsInLeftList > 6 || Object.keys(error).length > 0 || this.state.collection === '';
    return (
      <Dialog
        disableEscapeKeyDown
        fullWidth={true}
        open={open}
        onClose={close}
        aria-labelledby='skill-dialog-title'
        scroll='paper'
        PaperProps={{ classes:{ root: classes.container }}}
      >
        <DialogTitle disableTypography={true} className={ classes.title }>
          <Typography className={ classes.titleText } variant='h4' id='skill-dialog-title'><FormattedMessage id='Wizard.skillDB.title'/></Typography>
          <IconButton
            onClick={this.close}
            className={ classes.exitIcon }
            aria-label="close dialog button"
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Typography variant='h6'><FormattedMessage id='Wizard.skillDB.levelConfig'/></Typography>
          <FormGroup className={ classes.root }>
            <TextField
              select
              variant='outlined'
              label='Levels'
              name='level'
              onChange={this.handleLevelChange}
              value={this.state.selectedLevel}
            >
              {
                gameLevels.map(level => (<MenuItem key={level.id} value={level.id}> {level.name} </MenuItem>))
              }
            </TextField>
          </FormGroup>
          {level.id &&
          <div className={classes.level}>
            <FormGroup className={classes.configureLine}>
              <Typography className={classes.configTitle} variant='h6'><FormattedMessage id='General.description' />: </Typography>
              <br />
              <Typography variant='subtitle2'>{level.description}</Typography>
            </FormGroup>
            <FormGroup className={classes.configureLine}>
              <Typography className={classes.configTitle} variant='h6'><FormattedMessage id='Wizard.AudioMemory.collection'/>: </Typography>
              <TextField
                select
                variant='outlined'
                className={classes.configComponent}
                name='collection'
                type='select'
                value={this.state.collection}
                onChange={this.handleChange}
              >
                <MenuItem value={0}> <FormattedMessage id='Wizard.AudioMemory.animals'/> </MenuItem>
                <MenuItem value={1}> <FormattedMessage id='Wizard.AudioMemory.instruments'/> </MenuItem>
                <MenuItem value={2}> <FormattedMessage id='Wizard.AudioMemory.vehicles'/> </MenuItem>
                <MenuItem value={3}> <FormattedMessage id='Wizard.AudioMemory.indoors'/> </MenuItem>
                <MenuItem value={4}> <FormattedMessage id='Wizard.AudioMemory.toys'/> </MenuItem>
              </TextField>
            </FormGroup>
            <FormGroup className={classes.configureLine}>
              <Typography className={classes.configTitle} variant='h6'><FormattedMessage id='Wizard.AudioMemory.length'/>: </Typography>
              <TextField
                variant='outlined'
                className={classes.configComponent}
                name='lengthOfGame'
                type='number'
                value={this.state.lengthOfGame}
                error={error.lengthOfGame}
                helperText={error.lengthOfGame ? '* required' : ''}
                onChange={this.handleChange}
                onBlur={this.checkForErrors}
              />
            </FormGroup>
            <FormGroup className={classes.configureLine}>
              <Typography className={classes.configTitle} variant='h6'><FormattedMessage id='Wizard.Sounds.unlimited'/> </Typography>
              <TextField
                select
                variant='outlined'
                className={classes.configComponent}
                name='unlimitedMode'
                type='select'
                value={this.state.unlimitedMode || 0}
                onChange={this.handleChange}
              >
                [
                  <MenuItem key={false} value={0}><FormattedMessage id='General.no' /></MenuItem>,
                  <MenuItem key={true} value={1}><FormattedMessage id='General.yes' /></MenuItem>,
                ]
              </TextField>
            </FormGroup>
            {
              unlimitedMode === 0 &&
              <FormGroup className={classes.configureLine}>
                <Typography className={classes.configTitle} variant='h6'><FormattedMessage id='Wizard.Sounds.numBoards'/>: </Typography>
                <TextField
                  variant='outlined'
                  className={classes.configComponent}
                  name='numberOfBoards'
                  type='number'
                  error={error.numberOfBoards}
                  helperText={error.numberOfBoards ? '* required' : ''}
                  value={this.state.numberOfBoards}
                  onChange={this.handleChange}
                  onBlur={this.checkForErrors}
                />
              </FormGroup>
            }
            <FormGroup className={classes.configureLine}>
              <Typography className={classes.configTitle} variant='h6'><FormattedMessage id='General.difficulty'/>: </Typography>
              <TextField
                select
                variant='outlined'
                className={classes.configComponent}
                name='difficulty'
                value={this.state.difficulty}
                onChange={this.handleChange}
              >
                {
                  [
                    { value: 'Easy', text: <FormattedMessage id='General.easy' /> },
                    { value: 'Medium', text: <FormattedMessage id='General.medium' /> },
                    { value: 'Hard', text: <FormattedMessage id='General.hard' /> }
                  ].map(difficulty => (<MenuItem key={difficulty.value} value={difficulty.value}> {difficulty.text} </MenuItem>))
                }
              </TextField>
            </FormGroup>
          </div>
          }
        </DialogContent>
        <DialogActions className={classes.buttons}>
          <Button onClick={back} color='secondary'>
            <FormattedMessage id='General.back' />
          </Button>
          <Button
            onClick={ this.runTest }
            variant={ tested ? 'outlined' : 'text' }
            color={ tested ? 'secondary' : 'primary' }
          >
            { tested ? <FormattedMessage id='General.retest' /> : <FormattedMessage id='General.test' />}
          </Button>
          <Button onClick={this.handleSubmit} disabled={disabled} color='primary'>
            <FormattedMessage id='General.next' />
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

const  mapState = ({ platform: { levels }}) => {
  return {
    levels
  }
};

const mapDispatch = (dispatch) => {
  return {
    fetchLevels: () => dispatch(fetchLevels())
  }
};

export default connect(mapState, mapDispatch)(withStyles(baseStyle)(SoundSearchSkillDatabank));